import { Component, OnInit } from '@angular/core';

@Component({
 selector: 'asistencia',
 standalone: false,
 template: `<router-outlet></router-outlet>`
})

export class AsistenciaComponent implements OnInit {
 constructor() { }

 ngOnInit() { }
}